import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

export default function DataTableBasic(props) {
  let {
    columns,
    data,
    equalWidth,
    miniHeader,
    miniRow,
    rowKey,
    isRowBlue,
    blueRowDirection,
  } = props;

  const [listedData, setListedData] = useState(data);

  // gelen data değişirse rerender etmeli
  useEffect(() => {
    setListedData(data);
  }, [data]);

  const isBlue = (row) => {
    if (!blueRowDirection) return;
    return isRowBlue(row, blueRowDirection);
  };

  return (
    <div
      className={`km__c--table ${
        equalWidth ? 'km__c--table-is-equalwidth' : ''
      }`}
    >
      <div className='km__c--table-container'>
        <table>
          <thead className={`${miniHeader ? 'km__c-table-mini-header' : ''}`}>
            <tr>
              {columns.map((item) => {
                return (
                  <th
                    id={
                      item.key ? item.selector + '-' + item.key : item.selector
                    }
                    key={item.selector + '-' + item.key}
                    width={item.width}
                  >
                    {item.name}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody
            className={`
              ${miniRow ? 'km__c-table-mini-row' : ''} 
            `}
          >
            {listedData.map((dataItem, index) => {
              return (
                <tr
                  key={`${dataItem[rowKey]}-${index}`}
                  className={
                    isBlue(dataItem) ? 'km__c--table-mini-row-is-blue' : ''
                  }
                >
                  {columns.map((columnItem) => {
                    return (
                      <td
                        key={`${dataItem[rowKey]}-${columnItem.selector}-${columnItem.key}`}
                        title={dataItem[columnItem.selector]}
                      >
                        {/* özel renderlanacak olan bir cell varsa onu renderlar yoksa gelen value'yu renderlar */}
                        {columnItem.cell
                          ? columnItem.cell(dataItem)
                          : dataItem[columnItem.selector]}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
DataTableBasic.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  equalWidth: PropTypes.bool,
  miniHeader: PropTypes.bool,
  miniRow: PropTypes.bool,
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
DataTableBasic.defaultProps = {
  columns: [],
  data: [],
  equalWidth: false,
  miniHeader: false,
  miniRow: false,
  rowKey: 'id',
};
